import { useRouteError } from 'react-router'
import { JobErrorContainer } from '@/features/jobs/components/JobErrorContainer'

export default function CheckoutErrorBoundaryContainer() {
  return <JobErrorContainer error={useRouteError()} />
}
